import React from 'react';

const AdminPanel: React.FC<{ children: React.ReactNode; className?: string }> = ({
  children,
  className = '',
}) => (
  <section className={`admin-panel ${className}`.trim()}>{children}</section>
);

export default AdminPanel;

